module.exports = __webpack_public_path__ + "static/assets/9d92e9e6b54511b911524b791726cb2d.png";